module.exports = __webpack_public_path__ + "img/ico_plus_white.821c181f.svg";